// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"AchievementsPage_pageContainer__jpE6f","noAchievements":"AchievementsPage_noAchievements__2HtNd","icons":"AchievementsPage_icons__fe20X"};